import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'app/services/notification.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private skipUrls = ['/api/ht_cauhinhcoquan/systemconfig'];

    constructor(private injector: Injector,
        private notificationService: NotificationService,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).catch((err: any) => {
            console.log(`AuthInterceptor`, req.url);
            
            if (err instanceof HttpErrorResponse) {

                const shouldSkip = this.skipUrls.some(url => req.url.toLowerCase().includes(url));

                if (!shouldSkip && err.status === 401) {
                    localStorage.clear();
                    const router = this.injector.get(Router);
                    this.notificationService.printErrorMessage(err.error);
                    router.navigate(['/login']);
                }
            }
            return Observable.throw(err);
        });
    }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/shared/interceptor/auth-interceptor.ts